export const ALL_PAGINATED_LIST_ITEMS_PARAMS = { page: 1, limit: 0, searchText: '' };
